export default __webpack_public_path__ + "static/media/icon-medico-cerca-de-ti.afdc5ab2.svg";